// SidebarNavItem.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface SidebarNavItemProps {
    navigateTo: string;
    icon?: React.ReactNode;
    label: string;
    isActive?: boolean;
    onNavigate?: () => void;
}

const SidebarNavItem: React.FC<SidebarNavItemProps> = ({ 
    navigateTo, 
    icon, 
    label,
    isActive = false,
    onNavigate,
}) => {
    const navigate = useNavigate();
    
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // If Ctrl/Cmd key is pressed
        if (e.ctrlKey || e.metaKey) {
            // Let the browser handle opening in a new tab
            window.open(navigateTo, '_blank');
        } else {
            // Normal navigation - prevent default and use router
            e.preventDefault();
            navigate(navigateTo);
            
            // Close the sidebar when navigating
            if (onNavigate) {
                onNavigate();
            }
        }
    };

    return (
        <a
            href={navigateTo} 
            onClick={handleClick} 
            className={`sidebar-nav-item ${isActive ? 'active' : ''}`}
        >
            {icon && <span className="sidebar-icon">{icon}</span>} 
            <span className="sidebar-label">{label}</span>
        </a>
    );
};

export default SidebarNavItem;